import React from "react";
import "./EmptyState.css";
import EmptyImg from "../../../assets/empty-states/EmptyImg.svg";
import { useTranslation } from "react-i18next";

const EmptyState = ({
  image, // Custom image for "no data" state
  heading, // Custom heading for "no data" state
  subText, // Custom subtext for "no data" state
  buttonText, // Custom button text for "no data" state
  onButtonClick, // Button click handler
  hasData = false, // If true, shows filtered state
}) => {
  const { t } = useTranslation();
  // Default filtered state (when hasData is true)
  if (hasData) {
    return (
      <div className="empty-state-container">
        <img
          src={EmptyImg}
          alt="No records found"
          className="empty-state-image"
        />
        <h3 className="empty-state-heading">{t("No Records Found")}</h3>
        <p className="empty-state-subtext">
          {t(
            "There's nothing to show here right now. Try adjusting your search or filters.",
          )}
        </p>
      </div>
    );
  }

  // Custom "no data" state
  return (
    <div className="empty-state-container">
      {image && (
        <img src={image} alt="Empty state" className="empty-state-image" />
      )}

      {heading && <h3 className="empty-state-heading">{t(heading)}</h3>}

      {subText && <p className="empty-state-subtext">{t(subText)}</p>}

      {buttonText && onButtonClick && (
        <button onClick={onButtonClick} className="empty-state-button">
          {t(buttonText)}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
